import styles from './AlarmControls.module.css';

export default function AlarmControls({ store }) {
  const toggleMute = () => {
    store.setAudioMuted(!store.audioMuted);
  };

  return (
    <div className={styles.alarmControls}>
      <button className={styles.muteButton} onClick={toggleMute}>
        {store.audioMuted ? '🔇 Unmute Alarms' : '🔊 Mute Alarms'}
      </button>
      <p className={styles.hint}>
        Per-parameter alarm limits (<span className={styles.lo}>Lo</span> /{' '}
        <span className={styles.hi}>Hi</span>) are set under each vital in{' '}
        <strong>Vital Parameters</strong> above.
      </p>
    </div>
  );
}
